import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { View } from "ui/atoms/view";
import { Button } from "ui/gluestack/button";
import { Text } from "react-native";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  isAssigning: boolean;
  onSubmit: () => void;
}

export function AssignStatusFlagsModal({
  isVisible,
  onClose,
  isAssigning,
  onSubmit,
}: Props) {
  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      className="w-full max-w-[378px] mx-auto"
      title="Are you sure you want to update this resident's status?"
      description="This action will update the resident status with the newly selected flags. Please confirm if you want to proceed."
      hasCancelButton
    >
      <View className="flex flex-row justify-end gap-x-4 ">
        <Button action="primary" size="sm" variant="outline" onPress={onClose}>
          <Text className="text-primary-500 font-semibold">Cancel</Text>
        </Button>
        <Button
          action="negative"
          size="sm"
          isDisabled={isAssigning}
          onPress={onSubmit}
        >
          <Text className="text-white">Update</Text>
        </Button>
      </View>
    </ReusableModal>
  );
}
